// FAMILY-EXT: feature 1 — короткий двух-тоновый сигнал, генерируемый через
// Web Audio API. Файлов не требует. Браузеры блокируют автоплей до первого
// gesture'а пользователя, поэтому первый клик по странице "разогревает"
// AudioContext.

let audioCtx = null;

function ensureAudioCtx() {
  if (!audioCtx) {
    try {
      const Ctor = window.AudioContext || window.webkitAudioContext;
      if (!Ctor) return null;
      audioCtx = new Ctor();
    } catch (e) {
      return null;
    }
  }
  return audioCtx;
}

// Один раз "разогреваем" контекст на первом клике/тапе/клавише.
function setupOnce() {
  if (typeof document === 'undefined') return;
  const wake = () => {
    const ctx = ensureAudioCtx();
    if (ctx && ctx.state === 'suspended') {
      ctx.resume().catch(() => {});
    }
  };
  ['click', 'touchstart', 'keydown'].forEach((evt) => {
    document.addEventListener(evt, wake, { once: true, passive: true });
  });
}

setupOnce();

export function playReturnNotification() {
  const ctx = ensureAudioCtx();
  if (!ctx) return;
  if (ctx.state === 'suspended') {
    ctx.resume().catch(() => {});
  }

  const now = ctx.currentTime;
  const tones = [
    { freq: 880, start: 0, dur: 0.18 }, // A5
    { freq: 1318.5, start: 0.22, dur: 0.32 }, // E6
  ];

  tones.forEach(({ freq, start, dur }) => {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.frequency.value = freq;
    osc.type = 'sine';

    gain.gain.setValueAtTime(0, now + start);
    gain.gain.linearRampToValueAtTime(0.35, now + start + 0.02);
    gain.gain.linearRampToValueAtTime(0, now + start + dur);

    osc.start(now + start);
    osc.stop(now + start + dur);
  });
}
